import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimpleTable from 'components/shared/table/SimpleTable';
import './VendorInvoicesDetails.css';
import { vendorInvoicesSelector } from 'components/admin/work-orders/details/vendor-invoices/store/selectors';
import AddVendorInvoiceModal from 'components/admin/work-orders/details/vendor-invoices/AddVendorInvoiceModal';
import Button from 'components/shared/button/Button';
import {
  deleteVendorInvoice,
  setShowAddInvoiceModal,
} from 'components/admin/work-orders/details/vendor-invoices/store/actions';
import { toUpperFirstLetter } from 'services/utils/text-util';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import DocumentLink from 'components/shared/document/DocumentLink';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';

class VendorInvoicesDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmation: false,
      vendorInvoiceIdToDelete: null,
    };
  }

  handleDeleteConfirmation = (result) => {
    if (result) {
      this.props.dispatch(
        deleteVendorInvoice(this.state.vendorInvoiceIdToDelete)
      );
    }
    this.setState({
      showDeleteConfirmation: false,
      vendorInvoiceIdToDelete: null,
    });
  };

  mapInvoices = (invoices) => {
    return invoices.map((invoice) => {
      return [
        invoice.task_number,
        invoice.vendor_name,
        toUpperFirstLetter(invoice.status),
        <Date value={invoice.due_date} format="LL" />,
        <Number value={invoice.cost} format="$0,0.[00]" />,
        <DocumentLink showIcon={false} url={invoice.document.document.url} />,
        <Button
          className="button-blue-grey"
          label="Delete"
          onClick={() =>
            this.setState({
              showDeleteConfirmation: true,
              vendorInvoiceIdToDelete: invoice.id,
            })
          }
        />,
      ];
    });
  };

  render() {
    const headers = [
      'TASK #',
      'VENDOR NAME',
      'STATUS',
      'DUE DATE',
      'AMOUNT',
      'DOC LINK',
      '', // button
    ];

    return (
      <div className="vendor-invoices-details">
        <SimpleTable
          className="vendor-invoice-table"
          headers={headers}
          rows={this.mapInvoices(this.props.vendorInvoices)}
          emptyMessage="No Vendor Invoices"
        />
        <div>
          <Button
            className="button-orange buttons-container"
            label="Add Invoice"
            onClick={() => this.props.dispatch(setShowAddInvoiceModal(true))}
          />
        </div>
        <AddVendorInvoiceModal />
        <ConfirmationModal
          show={this.state.showDeleteConfirmation}
          message="Are you sure you want to delete the invoice?"
          onHide={this.handleDeleteConfirmation}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    vendorInvoices: vendorInvoicesSelector(state),
  };
})(VendorInvoicesDetails);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/vendor-invoices/VendorInvoicesDetails.js